import messages from './messages';
import {
  DEFAULT_TOAST_PARAMS,
  PRODUCT_TAGS,
  INVENTA_SHOP_PRODUCT_URL,
  SALES_FORMAT_OPTIONS,
  INVENTORY_POLICY,
  PRODUCT_STATUS,
} from '../../const';
import { extractTagValueFromTagsString } from 'src/utils/extractTagValueFromTagsString';

export const TOAST_MESSAGE_DESCRIPTOR = {
  FETCH_PRODUCT_FAILED: intl => ({
    ...DEFAULT_TOAST_PARAMS,
    description: intl.formatMessage(messages.fetchProductErrorToastDescription),
    status: 'error',
  }),
};

const mapImageDTOToData = imageDTO => imageDTO && { src: imageDTO.src };

const getProductTagNumberValueOrDefault = (tags, targetTag) => {
  const optionalTagValue = extractTagValueFromTagsString(tags, targetTag.key);

  if (!optionalTagValue) return targetTag.defaultValue;

  const parsedTagValue = Number(optionalTagValue);

  return Number.isNaN(parsedTagValue) ? targetTag.defaultValue : parsedTagValue;
};

const productIsInStock = variants => {
  const variantsAcceptingOrders = variants.filter(
    variant => variant.inventory_policy === INVENTORY_POLICY.CONTINUE,
  );

  if (variantsAcceptingOrders.length === 0) {
    return false;
  }

  const containsVariantsWithSameLenght =
    variantsAcceptingOrders.length === variants.length;

  return containsVariantsWithSameLenght;
};

export const mapProductDTOToProduct = productDTO => {
  const increaseAmountTagValue = getProductTagNumberValueOrDefault(
    productDTO.tags,
    PRODUCT_TAGS.INCREASE_AMOUNT,
  );
  const minimumPurchaseAmountTagValue = getProductTagNumberValueOrDefault(
    productDTO.tags,
    PRODUCT_TAGS.MINIMUM_PURCHASE_AMOUNT,
  );

  return {
    id: productDTO.id,
    name: productDTO.name,
    sku: productDTO.variants?.[0]?.sku?.split('|')[0] ?? '',
    description: productDTO.body_html || '',
    image: mapImageDTOToData(productDTO.image),
    tags: productDTO.tags,
    status: productDTO.status,
    inventaShopProductURL: INVENTA_SHOP_PRODUCT_URL + productDTO.handle,
    isDeliveredNationalWide: !productDTO.tags?.includes(
      PRODUCT_TAGS.NO_SHOW.key,
    ),
    increaseAmount: increaseAmountTagValue,
    salesFormat:
      increaseAmountTagValue === PRODUCT_TAGS.INCREASE_AMOUNT.defaultValue
        ? SALES_FORMAT_OPTIONS.UNIT
        : SALES_FORMAT_OPTIONS.BOX,
    minimumPurchaseAmount:
      minimumPurchaseAmountTagValue / increaseAmountTagValue,
    fullPrice: parseFloat(productDTO.full_price) || 0,
    discountPercentage: parseFloat(productDTO.discount_percentage) || 0,
    suggestedRetailPrice: parseFloat(productDTO.suggested_retail_price) || 0,
    variants: productDTO.variants,
    options: productDTO.options,
    isInStock: productDTO.variants && productIsInStock(productDTO.variants),
    isPublished: productDTO.status === PRODUCT_STATUS.ACTIVE,
  };
};
